import { render, staticRenderFns } from "./createQuestion.vue?vue&type=template&id=22c0dc87&"
import script from "./createQuestion.vue?vue&type=script&lang=js&"
export * from "./createQuestion.vue?vue&type=script&lang=js&"
import style0 from "./createQuestion.vue?vue&type=style&index=0&id=22c0dc87&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports